import { app } from '../../../../app';
import { Controller } from './reseller-list.controller';

app.component('companyResellerList', {
    controller: Controller,
    templateUrl: require('./reseller-list.html'),
    bindings:{
        companyId: '<',
        companies:'<'
    }
});


// WEBPACK FOOTER //
// ./src/portal/states/company/reseller/list/reseller-list.component.js